module.exports = __webpack_public_path__ + "static/media/telegram.b505e33b.svg";